import type { StickerIllustrationProps } from '../Sticker';

export const HandsHeartStickerIllustration = ({ size }: StickerIllustrationProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.6774 44.6057C24.702 43.8576 25.9603 43.3919 27.3013 43.3546L27.5708 43.3532L28.0423 43.3543C28.5269 43.3507 29.0579 43.3347 29.6833 43.321C30.4647 43.3038 31.3666 43.2919 32.24 43.3507C33.0892 43.4078 34.111 43.5416 35.0743 43.9106C36.0032 44.2665 37.0989 44.9328 37.7967 46.1586L37.931 46.4107L38.0954 46.7074C38.2936 47.0337 38.5939 47.4536 39.0062 47.9859C39.4647 48.5779 40.1751 49.4465 40.664 50.1279C40.9255 50.4925 41.2161 50.9258 41.4526 51.3846C41.6595 51.786 41.9937 52.5186 42.0183 53.4127C42.0493 54.5469 41.5616 55.7777 40.3953 56.547C39.4924 57.1426 38.5149 57.2283 37.9274 57.2376C36.3297 57.2629 34.9663 56.7355 33.9087 56.068C33.0976 55.5561 32.2443 55.6265 30.8904 55.6251C30.8135 55.625 30.7581 55.6271 30.7182 55.6277C30.0481 56.1902 28.9386 57.191 28.2225 58.4216C27.7943 59.1576 27.6445 59.7547 27.6705 60.2215C27.6913 60.5938 27.8361 61.1932 28.6377 62.0046L29.3578 61.9228C30.0474 61.8334 30.6285 61.7239 30.9599 61.6159C31.0174 61.5971 31.0889 61.5651 31.4144 61.4142C31.668 61.2967 32.1452 61.0736 32.6998 60.9212C34.3753 60.4608 37.0503 60.0001 39.4431 60.6642C40.5524 60.9721 41.7008 61.682 42.3272 62.976C42.9282 64.2175 42.7889 65.4651 42.4787 66.3597C41.8861 68.0685 40.4037 69.438 38.7158 70.0654C36.8644 70.7535 35.2603 71.4865 34.5009 72.0389C34.2037 72.2552 33.6089 72.7002 32.8835 73.0244L32.8825 73.0246C31.0161 73.8584 27.9965 75.0664 25.6114 75.5492C24.6477 75.7442 24.1952 75.7913 23.5458 75.9601C22.9885 76.105 22.7982 76.2318 22.7548 76.2681C22.1605 76.7661 21.5665 77.3333 21.0336 77.9415C19.7521 79.404 17.8773 80.5006 15.9438 80.8794C13.989 81.2623 11.345 80.9696 9.6254 78.6699C8.02237 76.526 6.73401 74.0996 5.8473 71.4446C5.36755 70.008 5.46769 68.4907 6.01826 67.1737C9.24606 59.4531 14.7378 51.1326 23.6774 44.6057Z"
        fill="#F1CED5"
        stroke="white"
        stroke-width="6.19402"
      />
      <path
        d="M63.0166 44.1558C61.9641 43.4297 60.6938 42.9718 59.3507 42.9107L59.0805 42.904L58.5633 42.8948C58.0314 42.8806 57.4511 42.852 56.7824 42.8251C55.9399 42.7911 54.9835 42.7615 54.0631 42.8011C53.1693 42.8395 52.1108 42.9487 51.1197 43.2853C50.184 43.6031 48.999 44.2349 48.2443 45.5004L48.0995 45.7618L48.0266 45.8939C47.8362 46.2204 47.4997 46.6742 46.9924 47.29C46.5144 47.8702 45.7597 48.7364 45.2444 49.4139C44.9686 49.7767 44.6582 50.2149 44.4056 50.6844C44.1858 51.0931 43.819 51.8654 43.8111 52.8201C43.801 54.0544 44.3976 55.2367 45.5243 55.9422C46.3968 56.4883 47.3387 56.5884 47.9419 56.6092C49.3566 56.6579 50.6068 56.3053 51.6466 55.7851L52.0791 55.5522C52.487 55.3175 52.9905 55.1855 53.5996 55.1336C54.2745 55.0761 54.7498 55.1242 55.496 55.1382C55.7809 55.1436 55.8277 55.1499 55.8662 55.1565C55.8671 55.1567 55.8688 55.1564 55.8711 55.1569C56.5958 55.7216 57.9447 56.8251 58.8104 58.1818C59.306 58.9586 59.4631 59.5516 59.447 59.968C59.4353 60.2676 59.328 60.8276 58.4637 61.6305C58.45 61.6329 58.4326 61.638 58.4107 61.6395C58.3722 61.6422 58.3259 61.642 58.2741 61.6363C57.1941 61.5159 56.1879 61.3444 55.6515 61.1722C55.5541 61.1409 55.4455 61.0928 55.1014 60.9388C54.8231 60.8143 54.3369 60.596 53.7803 60.4433C51.998 59.9545 49.1996 59.457 46.733 60.0493C45.6358 60.3127 44.3893 60.9718 43.7058 62.3288C43.0404 63.6503 43.2437 64.9744 43.595 65.8741C44.2651 67.5894 45.8385 68.9121 47.5289 69.5264C49.5444 70.2587 51.3477 71.049 52.235 71.6589C52.5681 71.888 53.1823 72.3204 53.9196 72.6391C55.9467 73.515 59.1905 74.7754 61.7183 75.2999C62.7217 75.5081 63.2651 75.5761 63.9851 75.7638C64.6241 75.9303 64.9098 76.0861 65.0291 76.18C65.695 76.7041 66.3619 77.2987 66.9622 77.9344C68.3301 79.3831 70.2903 80.468 72.2669 80.8663C74.2027 81.2563 76.9617 81.0897 78.7839 78.7949C80.479 76.6601 81.8306 74.2269 82.7407 71.5477C83.2534 70.0385 83.0914 68.4647 82.4722 67.1354L82.1236 66.399C78.4396 58.7762 72.4321 50.6517 63.0166 44.1558ZM49.8617 53.6174C49.8463 53.6512 49.8419 53.653 49.8602 53.619L49.8617 53.6174Z"
        fill="#F1CED5"
        stroke="white"
        stroke-width="6.19402"
      />
      <path
        d="M51.1836 13.25C57.5219 13.25 62.6621 18.3872 62.6621 24.7256C62.6621 30.3688 59.3391 35.6531 55.2744 39.7568C51.4533 43.6146 46.8795 46.5308 43.4395 47.8486C42.8061 48.0912 42.1051 48.0913 41.4717 47.8486C38.0316 46.5307 33.4576 43.6144 29.6367 39.7568C25.5721 35.6531 22.2501 30.3687 22.25 24.7256C22.25 18.3873 27.3894 13.2502 33.7275 13.25C37.2208 13.25 40.3504 14.8114 42.4551 17.2725C44.5597 14.811 47.69 13.2501 51.1836 13.25Z"
        fill="#BA0C2F"
        stroke="white"
        stroke-width="5.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M77.383 64L77.2125 64.7211C76.1087 69.3903 73.5897 73.6046 69.9999 76.7878"
        fill="#99C8DC"
      />
      <path
        d="M77.383 64L77.2125 64.7211C76.1087 69.3903 73.5897 73.6046 69.9999 76.7878"
        stroke="#D66D82"
        stroke-width="2.39128"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.418 75.7878L18.8788 75.2797C15.3871 71.9891 12.9969 67.7005 12.035 63"
        fill="#99C8DC"
      />
      <path
        d="M19.418 75.7878L18.8788 75.2797C15.3871 71.9891 12.9969 67.7005 12.035 63"
        stroke="#D66D82"
        stroke-width="2.39128"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M74.4631 19.8645L71.891 20.6864"
        stroke="white"
        stroke-width="4.29693"
        stroke-linecap="round"
      />
      <path
        d="M76.4373 27.2314L71.7307 26.2683"
        stroke="white"
        stroke-width="4.29693"
        stroke-linecap="round"
      />
      <path
        d="M71.4153 33.0255L69.0001 31.8179"
        stroke="white"
        stroke-width="4.29693"
        stroke-linecap="round"
      />
      <path
        d="M15.282 33.2096L17.0986 31.2117"
        stroke="white"
        stroke-width="4.29693"
        stroke-linecap="round"
      />
      <path
        d="M9.88892 27.8167L14.4465 26.2975"
        stroke="white"
        stroke-width="4.29693"
        stroke-linecap="round"
      />
      <path
        d="M11.3411 20.2878L14.0365 20.1261"
        stroke="white"
        stroke-width="4.29693"
        stroke-linecap="round"
      />
    </svg>
  );
};
